import axios, {AxiosRequestConfig} from 'axios'

const axiosCentral = axios.create({
  baseURL: process.env.DEV_API_CENTRAL_URL || process.env.REACT_APP_DEV_API_CENTRAL_URL,
  headers: {
    'Content-Type': 'application/json', // Ejemplo de tipo de contenido
  },
})
const axiosHoteleria = axios.create({
  baseURL:
    process.env.DEV_API_HOTELERIA_URL ||
    'https://khipu-uat.azurewebsites.net/back/hoteleria/backend/api/',
})

export const AxiosInterceptor = (user: any = null) => {
  let token = ''

  if (user && user.cambioContrasena && user.tokenPassword) {
    document.location = `/central/auth/recover-password?token=${user.tokenPassword}`
    return
  }

  if (!user) {
    user = JSON.parse(localStorage.getItem('persist:root') as string)?.user
    token = user ? JSON.parse(user)?.token : ''
  } else {
    token = user.token
  }
  const updateHeader = (request: AxiosRequestConfig) => {
    const newHeaders = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
    request.headers = newHeaders
    return request
  }
  axios.interceptors.request.use(
    (request: any) => {
      if (request.url?.includes('assets')) return request
      if (!token) return request
      return updateHeader(request)
    },
    (err: any) => Promise.reject(err),
  )

  axios.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      if (error?.response?.status === 401) {
        localStorage.removeItem('persist:root')
        document.location = '/central/auth'
      } else {
        return Promise.reject(error)
      }
    },
  )
}

export {axiosCentral, axiosHoteleria}
